"use strict";

export const AVAILABLE_RATINGS = [1, 2, 3, 4, 5];

export const DEFAULT_EMOTIONS = [
  "neutral",
  "happy",
  "sad",
  "angry",
  "afraid",
];

export const CHARACTER_MINIMUM_READY_DIALOGUES = 10;

export const CHARACTER_GOOD_READY_DIALOGUES = 25;

export const EMOTION_VOICE_IDS = {
  neutral: "dwo0oupDDyJeTBpyE6n3",
  happy: "6JwWE9DTC1jaWKrYtDv2",
  sad: "v9cWqsqq8OHjQwKSB2FB",
  angry: "lnyWAfuQnJNpm4YxQ864",
  afraid: "aAvpc7Y595HXDxXuv9SV",
};
